<!--
 * @Author: 熊望
 * @Date: 2021-03-12 17:36:24
 * @LastEditors: 熊望
 * @LastEditTime: 2021-06-04 16:09:10
 * @FilePath: /zxy-student-frontend/vue/src/modules/knowledge-operation/components/common-pagination.vue
 * @Description: 按钮分页组件
-->
<template>
    <div class='common-pagination'>
        <a-pagination
            v-model="currentPage"
            :item-render="itemRender"
            :page-size-options="pageSizeOptions"
            :show-size-changer="showSizeSelector"
            :hideOnSinglePage="hideOnSinglePage"
            :defaultPageSize="defaultPageSize"
            :total="total"
            @showSizeChange="handlerSizeChange"
            @change="handlerChangePage" />
    </div>
</template>

<script>
    export default {
        name: 'CommonPagination',
        props: {
            hideOnSinglePage: {
                type: Boolean,
                default: true,
            },
            showSizeSelector: {
                type: Boolean,
                default: false,
            },
            defaultPageSize: {
                type: Number,
                default: 20,
            },
            pageSizeOptions: {
                type: Array,
                default: () => (['10', '20', '30', '40']),
            },
            defaultPage: {
                type: Number,
                default: 1,
            },
            total: {
                type: Number,
                default: 0,
            },
            customRenderElement: {
                type: Function,
                default: null,
            },
        },
        data() {
            return {
                currentPage: this.defaultPage,
            };
        },
        mounted() {
        },
        methods: {
            handlerChangePage(page) {
                this.$emit('page-change', page);
            },
            handlerSizeChange(current, pageSize) {
                this.$emit('size-change', current, pageSize);
            },
            itemRender(current, type, originalElement) {
                if (this.customRenderElement && typeof this.customRenderElement === 'function') {
                    return this.customRenderElement(current, type, originalElement);
                }
                // if (type === 'prev') {
                //     return <a>上一页</a>;
                // }
                // if (type === 'next') {
                //     return <a>下一页</a>;
                // }
                return originalElement;
            },
        },
    };
</script>

<style lang="less">
    .common-pagination {
        .ant-table-pagination.ant-pagination {
            float: none;
            background: #fff;
            text-align: center;
            & .ant-pagination-item {
                min-width: 32px !important;
                height: 32px !important;
                border-radius: 2px;
            }
        }
        .ant-pagination-item a {
            vertical-align: middle;
            min-width: 32px !important;
            height: 32px !important;
            background-color: #ffffff;
            border-radius: 2px;
            border: 1px solid rgba(0, 0, 0, 0.15);
        }
        .ant-pagination-item.ant-pagination-item-active a,
        .ant-pagination-item.ant-pagination-item-active a {
            color: #1890ff !important;
            border-radius: 2px;
            background: #fff;
            border: 1px solid #1890ff;
        }

        .ant-pagination-prev .ant-pagination-item-link,
        .ant-pagination-next .ant-pagination-item-link {
            vertical-align: middle;
            margin-top: 2px;
            min-width: 32px !important;
            height: 32px !important;
            border: 1px solid rgba(0, 0, 0, 0.15) !important;
            display: inline-block !important;
            border-radius: 2px;
            svg {
                display: block!important;
            }
        }
        .ant-pagination-options {
            margin-top: 4px;
        }
    }
</style>

